export const numberToPosition = (number: number): string => {
    if(number === 1) {
        return 'first';
    } else if(number === 2) {
        return 'second';
    } else if(number === 3) {
        return 'third';
    } else if(number === 4) {
        return 'fourth';
    } else if(number === 5) {
        return 'fifth';
    } else if(number === 6) {
        return 'sixth';
    } else if(number === 7) {
        return 'seventh';
    } else if(number === 8) {
        return 'eighth';
    } else if(number === 9) {
        return 'ninth';
    } else if(number === 10) {
        return 'tenth';
    }
    return '';
}